import { getAnalytics, setAnalyticsCollectionEnabled } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth, GoogleAuthProvider } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { isProd } from './environment';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_APP_API_KEY,
  authDomain: import.meta.env.VITE_APP_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_APP_PROJECT_ID,
  storageBucket: import.meta.env.VITE_APP_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_APP_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_APP_APP_ID,
  measurementId: import.meta.env.VITE_APP_MEASUREMENT_ID,
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const googleAuthProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const functions = getFunctions(app);

// Local development against the Firebase Emulator Suite. Opt-in via
// `VITE_USE_FIREBASE_EMULATORS=true` (see `yarn start:emulator`) so production is
// never touched while testing roles/Cloud Functions. Auth, Firestore, and
// Functions all run locally and in isolation.
//
// Use the same host the page is served from (`localhost` vs `127.0.0.1`). The
// browser treats those as distinct origins, and the Auth emulator's popup
// sign-in relays the result back through a frame matched by origin — a mismatch
// produces "Auth Emulator Internal Error: No matching frame". Deriving the host
// keeps the popup origin aligned no matter which one you open the app with.
if (import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true') {
  const emulatorHost = window.location.hostname || '127.0.0.1';
  connectAuthEmulator(auth, `http://${emulatorHost}:9099`, { disableWarnings: true });
  connectFirestoreEmulator(db, emulatorHost, 8080);
  connectFunctionsEmulator(functions, emulatorHost, 5001);
}

// Enable analytics collection for production environment
setAnalyticsCollectionEnabled(analytics, isProd);
